import { observer } from "mobx-react-lite"
import React, { useState } from "react"
import { TextInput, type TextInputProps } from "@mantine/core"
import { DraftScheduleEventStore } from "app/store"

// ----------------------------------------------------------------------

export const ScheduleDraftSearch = observer(function ScheduleDraftSearch(props: TextInputProps) {
  const [ searchTimeout, setSearchTimeout ] = useState<ReturnType<typeof setTimeout>>()
  const [ value, setValue ] = useState<string>("")

  const handleSearch = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    setValue(target.value)

    if (searchTimeout) clearTimeout(searchTimeout)
    setSearchTimeout(setTimeout((search) => DraftScheduleEventStore.setSearchValue(search), 500, target.value))
  }

  return (
    <TextInput
      value={value}
      onChange={handleSearch}
      placeholder="Начните вводить название мероприятия"
      radius="md"
      mt="sm"
      mb="xl"
      {...props}
    />
  )
})

